import { render, staticRenderFns } from "./pendings.vue?vue&type=template&id=cbc4a0b4"
import script from "./pendings.vue?vue&type=script&lang=js"
export * from "./pendings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports